import type { StaticLayerPayload } from "@config";
import { PdfEntireSlideImageLibrary } from "@library-combos/pdfEntireSlideImage";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: PdfEntireSlideImageLibrary,
};

export const PdfEntireSlideImage = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
